<template>
  <v-card>
    <v-card-title class="align-start">
      <span>Income Statistics</span>
      <v-spacer></v-spacer>
    </v-card-title>

    <v-card-text>
      <!-- Chart -->
      <vue-apex-charts
        :options="chartOptions"
        :series="chartData"
        height="210"
        width="470"
      ></vue-apex-charts>

      <div class="d-flex align-center">
        <span>Your Income Statistics Per Month</span>
      </div>

      <v-btn
        block
        color="primary"
        class="mt-6"
        outlined
      >
        Details
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
// eslint-disable-next-line object-curly-newline
import axios from 'axios'

export default {
  components: {
    VueApexCharts,
  },
  data() {
    return {
      chartData: [
        {
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
          offsetX: 0,
        },
        stroke: {
          show: true,
          curve: 'smooth',
          lineCap: 'butt',
          colors: '#ff6600',
          width: 2,
          dashArray: 0,
        },
        title: {
          text: 'Your Income / Per month',
          align: 'left',
          style: {
            color: '#56ca00',
          },
        },
        grid: {
          row: {
            colors: ['#56ca00', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0,
          },
        },
        yaxis: {
          labels: {
            formatter(value) {
              let val = Math.abs(value)

              if (val >= 10 ** 3 && val < 10 ** 6) {
                val = `Rp ${(val / 1000).toFixed(0)} K`
              } else if (val >= 10 ** 6) {
                val = `Rp ${(val / 1000000).toFixed(0)} M`
              } else {
                val = val
              }

              return val
            },
          },
        },
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
        },
      },
    }
  },
  mounted() {
    this.getStatistikIncome()
  },
  methods: {
    getStatistikIncome() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/getStatistikIncome').then(response => {
        // this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.dialogstatus = false
        this.chartData[0].data = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors

        //   this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
